import * as logger from '../../../abt-utils/logger'
import * as shared from '../shared'
import { applyDefault } from '../../../abt-utils/structure'

export function customCriteria (test) {
  return shared.customCriteria(test, '#mobile-header') ? test : null
}

export function a (test) {
  return System.import('./a')
    .then(applyDefault(test))
    .catch(logger.error)
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt577/small/index.js
 ** module id = 61
 ** module chunks = 2
 **/